import { IDHFSection, IDHFControlDefinition } from "../../../common/businesslogic/index";
import { ml } from "../../../common/matrixlib";
import { IBaseControlOptions } from "../../../common/UI/Controls/BaseControl";
import { IDropdownOption } from "../../../ProjectSettings";
import { IRemarkOptions } from "../../../common/businesslogic/FieldHandlers/Document/RemarksDocFieldHandler";
import { BaseDHFSection } from "./BaseDHFSection";

export { Remarks };

class Remarks extends BaseDHFSection<IRemarkOptions> implements IDHFSection {
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    showSpecificSettings(ctrl: IDHFControlDefinition, ctrlParameter: IBaseControlOptions, custom: JQuery) {}

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    async saveSpecificSettingsAsync(ctrl: IDHFControlDefinition, ctrlParameter: IBaseControlOptions, custom: JQuery) {
        // save global settings
        let controllerConfig = this.getConfig(ctrl);
        this.fieldHandler.setDHFConfig(controllerConfig);

        // nothing changed
        return false;
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    renderControl(ctrl: IDHFControlDefinition, ctrlParameter: IBaseControlOptions) {
        let lines: IDropdownOption[] = [];
        for (let udx = 0; udx < 50; udx++) {
            lines.push({ id: udx.toString(), label: udx + " lines" });
        }

        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
        ctrl.control.mxDropdown(
            ml.JSON.mergeOptions(ctrlParameter, {
                parameter: {
                    placeholder: "select number of lines",
                    create: false,
                    options: lines,
                    maxItems: 1,
                    sort: false,
                },
            }),
        );
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    async verifyContentAsync(ctrl: IDHFControlDefinition) {}
}
